<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card>
        <div>
          <div class="w-full">
            <template v-if="entityTabs.length > 0">
              <vs-tabs
                alignment="fixed"
                :value="activeTab"
                @input="onTabChange"
                :key="tabsKey"
              >
                <template>
                  <vs-tab
                    v-for="entity in entityTabs"
                    :key="entity"
                    :label="entityTabLabels[entity] || entity"
                  >
                    <div
                      v-if="
                        entityDataMap[entity] && entityDataMap[entity].length
                      "
                      class="mr-2 mb-1 order-1"
                    >
                      <vs-table
                        :max-items="descriptionItems[0]"
                        pagination
                        :data="entityDataMap[entity] || []"
                        description
                        search
                        :description-items="descriptionItems"
                        description-title="Registries"
                        description-connector="of"
                        description-body="Pages"
                      >
                        <template slot="header">
                          <div class="list-heading">
                            {{ $t("admin.label.MakerCheckerApprovals") }}
                          </div>
                        </template>
                        <template slot="thead">
                          <vs-th>{{ $t("system.label.id") }}</vs-th>
                          <vs-th>{{ $t("admin.label.Maker") }}</vs-th>
                          <vs-th>{{ $t("inventory.label.Entity Name") }}</vs-th>
                          <vs-th>{{ $t("admin.label.ActionName") }}</vs-th>
                          <vs-th>{{ $t("admin.label.CreatedOn") }}</vs-th>
                          <vs-th class="tHeadCenter">{{
                            $t("admin.label.Actions")
                          }}</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                          <vs-tr
                            :key="index"
                            :data="approval"
                            v-for="(approval, index) in data"
                          >
                            <vs-td
                              v-if="
                                approval.entityName === 'CUSTOMERAVAILABILITY'
                              "
                              :data="approval.commandAsJson"
                              >{{
                                getUserIdFromJson(approval.commandAsJson)
                              }}</vs-td
                            >
                            <vs-td v-else :data="approval.resourceId">{{
                              approval.resourceId
                            }}</vs-td>
                            <vs-td :data="approval.maker">{{
                              approval.maker
                            }}</vs-td>
                            <vs-td :data="approval.entityName">{{
                              approval.entityName
                            }}</vs-td>
                            <vs-td :data="approval.actionName">{{
                              approval.actionName
                            }}</vs-td>
                            <vs-td :data="approval.madeOnDate">{{
                              getDate(approval.madeOnDate)
                            }}</vs-td>
                            <vs-td class="whitespace-no-wrap">
                              <div class="container_img">
                                <feather-icon
                                  icon="EyeIcon"
                                  :title="$t('system.label.View')"
                                  svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                                  @click.stop="
                                    handleView(approval.id, approval)
                                  "
                                  class="icon_row"
                                />
                              </div>
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </vs-tab>
                </template>
              </vs-tabs>
            </template>
            <template v-else>
              <vs-table
                :max-items="descriptionItems[0]"
                pagination
                :data="[]"
                description
                search
                :description-items="descriptionItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("admin.label.MakerCheckerApprovals") }}
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("system.label.id") }}</vs-th>
                  <vs-th>{{ $t("admin.label.Maker") }}</vs-th>
                  <vs-th>{{ $t("inventory.label.Entity Name") }}</vs-th>
                  <vs-th>{{ $t("admin.label.ActionName") }}</vs-th>
                  <vs-th>{{ $t("admin.label.CreatedOn") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("admin.label.Actions")
                  }}</vs-th>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('admin.label.Reject')"
        :active.sync="rejectPopup"
        class="popup-close mid-popup"
      >
        <form>
          <div class="vx-row">
            <div class="vx-col w-full mb-6">
              <small class="date-label">{{ $t("admin.label.Comment") }}</small>
              <vs-textarea v-model="checkerComment" />
            </div>
          </div>
          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button
                @click="approveRejectMethod('reject')"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("customers.label.confirm") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('admin.label.Approve')"
        :active.sync="approvePopup"
        class="popup-close mid-popup"
      >
        <form>
          <div class="vx-row">
            <div class="vx-col w-full mb-6">
              <small class="date-label">{{ $t("admin.label.Comment") }}</small>
              <vs-textarea v-model="checkerComment" />
            </div>
          </div>
          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button
                @click="approveRejectMethod('approve')"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("customers.label.confirm") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      descriptionItems: [5, 10, 15],
      approvePopup: false,
      rejectPopup: false,
      approvalId: null,
      rejectComment: "",
      checkerComment: "",
      creditLimitAmount: "",
      leaveData: null,
      activeTab: 0,
      tabsKey: 0,
    };
  },

  components: {
    AtomSpinner,
  },
  computed: {
    ...mapState({
      listToApprove: (state) => state.admin.listToApprove,
    }),
    entityTabs() {
      if (!this.listToApprove || !Array.isArray(this.listToApprove)) return [];
      const uniqueEntities = [
        ...new Set(this.listToApprove.map((item) => item.entityName)),
      ];
      return uniqueEntities;
    },
    entityTabLabels() {
      return {
        CUSTOMERAVAILABILITY: "Leave",
        CLIENTCREDITLIMIT: "Credit Limit",
        PLANSTATUS: "Plan",
      };
    },
    entityDataMap() {
      // Map of entityName to its list
      const map = {};
      if (!this.listToApprove || !Array.isArray(this.listToApprove)) return map;
      this.listToApprove.forEach((item) => {
        if (!map[item.entityName]) map[item.entityName] = [];
        map[item.entityName].push(item);
      });
      return map;
    },
  },
  watch: {
    entityTabs: {
      handler(newTabs) {
        if (this.activeTab >= newTabs.length) {
          this.activeTab = 0;
        }
        this.tabsKey += 1;
      },
      immediate: true,
    },
    listToApprove: {
      handler() {
        this.tabsKey += 1;
      },
      deep: true,
    },
  },
  methods: {
    onTabChange(val) {
      this.activeTab = val;
    },
    getDate(d) {
      if (!d) return "";
      const date = new Date(d);
      const day = String(date.getDate()).padStart(2, "0");
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day} ${month} ${year} ${hours}:${minutes}`;
    },
    async getListToApprove() {
      this.loading = true;
      try {
        await this.$store.dispatch("admin/getListToApproveAction");
        this.activeTab = 0;
        this.tabsKey += 1;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async approvalRequest(request) {
      let payload = { id: this.approvalId, permission: request };
      try {
        await this.$store.dispatch("admin/getPermission", payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      if (request == "approve") {
        this.approvePopup = false;
      } else this.rejectPopup = false;
      this.getListToApprove();
    },
    handleView(id, approval) {
      if (approval.entityName == "CLIENTCREDITLIMIT") {
        const commandAsJson = approval && approval.commandAsJson;
        try {
          const parsedCommand = JSON.parse(commandAsJson);
          this.creditLimitAmount = parsedCommand.amount;
        } catch (error) {
          this.creditLimitAmount = "NaN";
        }
        this.$swal
          .fire({
            title: "Approve or Reject",
            html: `<h5 style='display: block; text-align: center;'>Updated Credit Limit : ${this.creditLimitAmount}</h5>`,
            icon: "info",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "Approve",
            cancelButtonText: "Reject",
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#fd7e14",
            customClass: {
              confirmButton: "no-outline-btn",
              cancelButton: "no-outline-btn",
            },
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.approvePopup = true;
              this.approvalId = id;
            } else if (result.dismiss === this.$swal.DismissReason.cancel) {
              this.rejectPopup = true;
              this.approvalId = id;
            }
          });
      } else if (approval.entityName == "CUSTOMERAVAILABILITY") {
        const commandAsJson = approval && approval.commandAsJson;
        try {
          const parsedCommand = JSON.parse(commandAsJson);
          this.leaveData =
            parsedCommand &&
            parsedCommand.availabilities &&
            parsedCommand.availabilities[0];
        } catch (error) {
          this.creditLimitAmount = "NaN";
        }
        this.$swal
          .fire({
            title: "Leave Approve or Reject",
            html: `
              <div style='display: block; text-align: center;'>
                <div>User Name : ${this.leaveData.userName || ""}</div>
                <div>Start Date : ${
                  this.leaveData.sessionDate || ""
                } &nbsp; | &nbsp; End Date : ${
              this.leaveData.sessionEndDate || ""
            }</div>
              </div>
            `,
            icon: "info",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "Approve",
            cancelButtonText: "Reject",
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#fd7e14",
            customClass: {
              confirmButton: "no-outline-btn",
              cancelButton: "no-outline-btn",
            },
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.approvePopup = true;
              this.approvalId = id;
            } else if (result.dismiss === this.$swal.DismissReason.cancel) {
              this.rejectPopup = true;
              this.approvalId = id;
            }
          });
      } else {
        this.$router.push(
          `/setup/plan-pricing/viewplan/${approval.resourceId}?from=approval&approvalId=${id}`
        );
      }
    },
    getUserIdFromJson(commandAsJson) {
      try {
        const parsedCommand = JSON.parse(commandAsJson);
        return (
          (parsedCommand &&
            parsedCommand.availabilities &&
            parsedCommand.availabilities[0] &&
            parsedCommand.availabilities[0].userId) ||
          ""
        );
      } catch (error) {
        return "Invalid JSON";
      }
    },
    async approveRejectMethod(action) {
      try {
        const payload = {
          id: this.approvalId,
          action,
          data: {},
        };
        if (action == "reject") {
          payload.data.checkerComment = this.checkerComment;
          this.rejectPopup = false;
        }
        if (action === "approve") {
          payload.data.checkerComment = this.checkerComment;
          this.approvePopup = false;
        }
        await this.$store.dispatch("planPrice/approvalAction", payload);
        let msg =
          action === "approve"
            ? "Successfully Approved"
            : "Successfully Rejected";

        if (action === "reject") {
          this.$toasted.error(msg, {
            duration: 2000,
          });
        }
        if (action === "approve") {
          this.$toasted.success(msg, {
            duration: 2000,
          });
        }
        this.checkerComment = "";
        await this.getListToApprove();
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      } catch (error) {
        this.$toasted.error(error.message, {
          duration: 2000,
        });
      }
    },
  },
  async mounted() {
    await this.getListToApprove();
  },
};
</script>
<style>
.no-outline-btn:focus {
  outline: none !important;
  box-shadow: none !important;
}
</style>
